import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9eb43c1b-4d2e-4271-9c32-e74ba97db8fa/artifacts/sq81vyyj_LogoTenome.png";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-black py-16 md:py-24">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/">
              <img src={LOGO_URL} alt="Tenome" className="h-12 w-auto" />
            </Link>
            <p className="mt-4 text-neutral-400 max-w-md leading-relaxed">
              Premium 3D printed art sculptures inspired by your favorite movies and series. 
              Each piece is a handcrafted tribute to cinema's most iconic moments.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white">Navigate</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/shop" className="text-neutral-400 hover:text-white transition-colors">
                  Shop Collection
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-neutral-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-neutral-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-neutral-400 hover:text-white transition-colors">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white">Contact</h4>
            <ul className="space-y-4 text-neutral-400">
              <li>
                <span>Northampton, UK</span>
              </li>
              <li>
                <a href="tel:07786025399" className="hover:text-white transition-colors">
                  07786 025399
                </a>
              </li>
              <li>
                <a href="mailto:hello@tenome.com" className="hover:text-white transition-colors">
                  hello@tenome.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {new Date().getFullYear()} Tenome. All rights reserved.
          </p>
          <p className="text-neutral-500 text-sm">
            Handcrafted with passion
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
